import types from "../../actions/types"

export default function read(state, action) {
  switch (action.type) {
    case types.read:
      return {
        ...state,
      }
    case types.readSuccess:
      return {
        ...state,
        data: action.data,
      }
    case types.readError:
      return {
        ...state,
        data: null,
        error: action.error,
      }
    case types.readCancel:
      return {
        ...state,
      }
    default:
      return state
  }
}
